import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import EntityUpdater from '../EntityUpdater.js';
import { InitiateDNSButton } from '../InitiateDNS.js';
const Websites = (props) => {
    const { heading, collector } = props;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, heading),
        React.createElement(EntityUpdater, { key: "website", entity: "website", collector: collector }),
        React.createElement(EntityUpdater, { key: "clientWebBase", entity: "clientWebBase", collector: collector, disabled: !(me && exclusiveContent?.includes(me.id)) }),
        React.createElement(EntityUpdater, { key: "debtorWebBase", entity: "debtorWebBase", collector: collector, disabled: !(me && exclusiveContent?.includes(me.id)) }),
        React.createElement(InitiateDNSButton, { collectorId: collector.collectorId })));
};
export default Websites;
//# sourceMappingURL=Websites.js.map